import { EIntegrationPlatform } from "../../models/integrations.model";
import { apiWorker } from "../apiWorker";
import { getIntegrations } from "../integrations.service";

export type TGoogleToken = {
  access_token: string;
  expires_in: number;
  scope: string;
  token_type: string;
  id_token: string;
};

export type TGooglePhoto = {
  id: string;
  productUrl: string;
  baseUrl: string;
  mimeType: string;
  mediaMetadata: {
    creationTime: string;
    width: string;
    height: string;
    photo: {};
  };
  filename: string;
};

export type TGoogleAlbum = {
  id: string;
  title: string;
  productUrl: string;
  mediaItemsCount: string;
  coverPhotoBaseUrl: string;
  coverPhotoMediaItemId: string;
};

export function authGooglePhotos({
  onSuccess,
  onError,
  accessToken,
}: {
  accessToken: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    body: {
      code: accessToken,
    },
    url: `/integrations/google/photos/auth`,
    method: "POST",
    onSuccess,
    onError,
  });
}

export function refreshGooglePhotos({
  onSuccess,
  onError,
  accessToken,
}: {
  accessToken: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    body: {
      code: accessToken,
    },
    url: `/integrations/google/photos/refresh`,
    method: "POST",
    onSuccess,
    onError,
  });
}

export async function getGooglePhotosItems({
  pageToken,
  onSuccess,
  onError,
}: {
  pageToken?: string;
  onSuccess?: (data: {
    mediaItems: TGooglePhoto[];
    nextPageToken: string;
  }) => void;
  onError?: (data: any) => void;
}) {
  getIntegrations({
    onSuccess: async (data) => {
      const existingGooglePhotos = data.content.find(
        (integration) =>
          integration.platform === EIntegrationPlatform.GOOGLE_PHOTOS
      );

      if (existingGooglePhotos) {
        const response = await fetch(
          `https://photoslibrary.googleapis.com/v1/mediaItems?pageSize=100&${
            pageToken ? `pageToken=${pageToken}` : ""
          }`,
          {
            headers: {
              Authorization: `Bearer ${existingGooglePhotos.accessToken}`,
            },
          }
        );

        if (!response.ok) {
          const errorStatus = await response.json();

          return onError?.(errorStatus);
        }

        const data = (await response.json()) as {
          mediaItems: TGooglePhoto[];
          nextPageToken: string;
        };

        return onSuccess?.(data);
      }

      onError?.("Google Photos integration not found.");
    },

    onError,
  });
}

export function downloadGooglePhotosItems({
  items,
  accessToken,
  onSuccess,
  onError,
}: {
  accessToken: string;
  items: string[];
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    url: `/integrations/google/photos/download`,
    method: "POST",
    body: {
      items,
      access_token: accessToken,
    },
    onSuccess,
    onError,
  });
}
